/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'

icon.register({
  'trainresult': {
    width: 64,
    height: 64,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M874.7 64H149.3c-23.5 0-42.7 19.2-42.7 42.7v810.7c0 23.5 19.2 42.7 42.7 42.7h725.3c23.5 0 42.7-19.2 42.7-42.7V106.7c0-23.5-19.2-42.7-42.6-42.7zm0 832c0 11.7-9.6 21.3-21.3 21.3H170.7c-11.7 0-21.3-9.6-21.3-21.3V128c0-11.7 9.6-21.3 21.3-21.3h682.7c11.7 0 21.3 9.6 21.3 21.3v768z"/><path pid="1" d="M325.4 445.6h120.9l29.6 79.5h41.4L406.8 234.7h-40.1L256 525.1h41.4l28-79.5zM380.7 292c1.8-4.8 3.3-11.5 4.7-20.3h.9c1.6 9.6 3.1 16.4 4.5 20.3l43.9 120.8h-97.5L380.7 292zm216.1 92h22.1v-63.5h63.8v-22.4h-63.8v-63.4h-22.1v63.4h-63.5v22.4h63.5zm149.9 234.7H277.3c-11.7 0-21.3 9.6-21.3 21.3s9.6 21.3 21.3 21.3h469.3c11.7 0 21.3-9.6 21.3-21.3s-9.5-21.3-21.2-21.3zm0-136.3H576c-11.7 0-21.3 9.6-21.3 21.3 0 11.7 9.6 21.3 21.3 21.3h170.7c11.7 0 21.3-9.6 21.3-21.3 0-11.7-9.6-21.3-21.3-21.3zm0 264.3H277.3c-11.7 0-21.3 9.6-21.3 21.3s9.6 21.3 21.3 21.3h469.3c11.7 0 21.3-9.6 21.3-21.3s-9.5-21.3-21.2-21.3z"/>'
  }
})
